import React from 'react'
import styled from 'styled-components'
import { compose } from 'redux'
import { withData } from '../decorators/with-data'
import { withRouter } from 'react-router'
import { withTranslations } from '../decorators/with-translations'
import gql from 'graphql-tag'

const referenceKPIs = gql`
  query ReferenceKPIs($surveyId: UUID! $languageCode: String) {
    referenceKpis(surveyId: $surveyId languageCode: $languageCode) {
      id
      title
      value
      unit
      date
    }
  }
`

const ReferenceKPIs = (props) => {
  function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
  }

  const {
    useTranslate,
    referenceKpis
  } = props;

  return (
    <div>
      {referenceKpis && referenceKpis.length > 0 &&
        <Wrapper>
          <h3>{useTranslate("dashboard.reference_kpis_title")}</h3>
          <p className={"mb-4"}>{useTranslate("dashboard.reference_kpis_description")}</p>
          <KPIsContainer>
            {referenceKpis.map((kpi, index) => {
              return (
                <div key={index} className={"kpi-item"}>
                  <KPITitle>{kpi.title}</KPITitle>
                  <KPIValue>{formatNumber(kpi.value)}<span>{kpi.unit}</span></KPIValue>
                  {kpi.date !== '' && <KPIDate>{kpi.date}</KPIDate>}
                </div>
              )
            })}
          </KPIsContainer>
        </Wrapper>
      }
    </div>
  )
}

export default compose(
  withRouter,
  withTranslations,
  withData(referenceKPIs, {
    options: ({ match }) => {
      const {
        params: { surveyId, languageCode }
      } = match;

      const variables = {
        surveyId,
        languageCode
      }

      return {
        variables
      }
    }
  }),
)(ReferenceKPIs);

const Wrapper = styled.div`
  margin-top: 3rem;
  background-color: #F7F7F7;
  border-radius: 10px;
  text-align: center;
  padding: 1.5rem 1rem;
`;

const KPIsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: flex-start;
  column-gap: 1rem;
  row-gap: 1rem;

  .kpi-item {
    background-color: #fff;
    border-radius: 10px;
    padding: 1rem;
    width: 200px;
    align-self: stretch;
  }
`;

const KPITitle = styled.h6`
  font-weight: 500;
  font-size: 15px;
  margin-bottom: 0;
`;

const KPIValue = styled.div`
  color: #F58220;
  font-weight: 700;
  font-size: 28px;
  
  span {
    font-size: 20px;
  }
`;

const KPIDate = styled.div`
  font-size: 13px;
`;


// WEBPACK FOOTER //
// ./src/components/reference-KPIs.js